import {Component, OnInit, OnDestroy} from '@angular/core';
import {MessageService} from '../message.service';
import {Router} from '@angular/router';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

import {Column, GridOption, AngularGridInstance, Formatters} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {NotifierService} from 'angular-notifier';
import {RestApiService} from '../rest-api.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-asset-validation',
    templateUrl: './asset-validation.component.html',
    styleUrls: ['./asset-validation.component.css']
})
export class AssetValidationComponent implements OnInit {

    masterNameSelected: number;
    masterName: string;
    description: string;
    clients: any[];
    clientId: number;

    displayData: any;
    isError = false;
    errorMessage: string;
    respObject: any;
    totalData: number;
    masterNameObj = [];
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    add = false;
    del = false;
    edit = false;
    view = false;
    private baseFlag: any;
    private userAuth: Subscription;
    private notifier: NotifierService;
    offset: number;

    columnNameSelected: number;
    columnNameObj = [];
    validationValues: string;
    dataLoaded: boolean;

    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            // console.log(item);
            switch (item.type) {
                case 'change':
                    if (!this.messageService.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            item.createdBy = this.messageService.getUserId();
                            item.client_id = this.clientId;
                            this._rest.editAssetValidation(item).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    // console.log('data--Done');
                                    this.notifier.notify('success', 'Updated successfully');
                                } else {
                                    // console.log('data--Not---Done');
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', JSON.stringify(err));
                            });
                        }
                    }
                    break;
                case 'delete':
                    // console.log('deleted');
                    if (!this.messageService.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            // console.log(JSON.stringify(item));
                            this._rest.deleteAssetValidation({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    // this.totalData = this.totalData - 1;
                                    // this.messageService.setTotalData(this.totalData);
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', JSON.stringify(err));
                            });
                        }
                    }
                    break;
            }
        });
    }

    ngOnInit() {
        this.dataLoaded = false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this.displayData = {
            pageName: ' Maintain Asset Validation',
            openModalButton: 'Add Validation',
            breadcrumb: 'Asset ID',
            folderName: 'All Asset ID',
            tabName: 'Asset ID'
        };

        // this.masterNameObj = [{id: 1, name: 'asset master1'}, {id: 2, name: 'asset master2'}, {id: 3, name: 'asset master3'}];
        // this.masterNameObj.unshift({id: 0, name: 'Select asset master name'});
        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
            {
                id: 'masterName', name: 'Digital Asset Type', field: 'masterName', sortable: true, filterable: true
            },
            {
                id: 'columnName', name: 'Digital Asset Attribute', field: 'columnName', sortable: true, filterable: true
            },
            {
                id: 'validationValue', name: 'Validation Value', field: 'validationValue', sortable: true, filterable: true, cssClass: 'highlight', editor: {
                    model: CustomInputEditor,
                }
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
                this.view = auth[0].viewFlag;
                this.add = auth[0].addFlag;
                this.edit = auth[0].editFlag;
                this.del = auth[0].deleteFlag;
                this.clientId = auth[0].clientId;
                this.baseFlag = auth[0].baseFlag;
                this.onPageLoad();
            });
        }
    }

    onPageLoad() {
        this._rest.getAssetManagementMaster(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                const dataArr = this.respObject.details;
                console.log('master data=', dataArr);
                this.masterNameObj = dataArr;
                this.masterNameObj.unshift({id: 0, masterName: 'Select asset master name'});
                this.totalData = dataArr.length;
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
        this.getTableData();
    }

    openModal(content) {
        if (!this.messageService.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.masterNameSelected = 0;
            this.masterName = '';
            this.description = '';
            this.errorMessage = '';

            this.columnNameObj = [];
            this.columnNameSelected = 0;

            this.modalService.open(content, {}).result.then((result) => {
            }, (reason) => {

            });
        }
    }

    save() {
        const data = {
            client_id: this.clientId,
            masterId: this.masterNameSelected,
            columnId: this.columnNameSelected,
            validationValuesArray: [],
            createdBy: this.messageService.getUserId()
        };

        if (!this.messageService.isBlankField(data)) {
            if(this.validationValues == undefined || this.validationValues == ""){
                this.isError = true;
                this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
                return;
            }else if(this.masterNameSelected == 0 || this.columnNameSelected == 0){
                this.isError = true;
                this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
                return;
            }
            console.log('asset description insert data:' , data);
            const validationValueArr = this.validationValues.split(',');
            data.validationValuesArray = validationValueArr;
            this._rest.addAssetValidation(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    alert("Added Successfully");
                    this.masterNameSelected = 0;
                    this.columnNameSelected = 0;
                    this.validationValues = '';
                    this.columnNameObj = [];
                    // this.getSupportGroup();
                    this.isError = false;
                    this.errorMessage = "";
                    this.getTableData();
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = err;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        if (!this.messageService.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded=false;
        this._rest.allAssetValidation(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onMasterChange(value: any) {
        this.masterName = this.masterNameObj[value].masterName;
        // =================================== get column name================================
        this._rest.getAssetColumnByMaster(this.clientId, this.masterNameSelected).subscribe((res) => {
            this.respObject = res;
            // console.log(this.respObject)
            if (this.respObject.success) {
                this.columnNameObj = this.respObject.details;
                this.columnNameObj.unshift({columnId: 0, columnName: 'Select asset column name'});

            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    ngOnDestroy(): void {
        if (this.userAuth) {
            this.userAuth.unsubscribe();
        }
    }

}
